import { Typology, Status } from '@/components';
import { t } from 'i18next';
import { useMemo } from 'react';
import { ColumnDef } from '@/components/Table/types';
import { RequestKpi } from '@/modules/Requests/domain';
import { KpiDetailsModal } from '../KpiDetailsModal';
import { KpiFilterType, KpiOrderByType } from '@/shared';

const allowedFilterByTypes = [
  KpiFilterType.Typology,
  KpiFilterType.Claimant,
  KpiFilterType.Status,
  KpiFilterType.Reference,
];

const allowedOrderByTypes = [
  KpiOrderByType.CreationDateDesc,
  KpiOrderByType.CreationDateAsc,
  KpiOrderByType.Typology,
  KpiOrderByType.Status,
  KpiOrderByType.Claimant,
];

interface RequestsKpiDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RequestsKpiDetailsModal = ({
  isOpen,
  onClose,
}: RequestsKpiDetailsModalProps) => {
  const columns = useMemo<ColumnDef<RequestKpi>[]>(
    () => [
      {
        id: 'reference',
        name: t('kpi_reference_column'),
        accessor: 'reference',
      },
      {
        id: 'title',
        name: t('kpi_title_column'),
        accessor: 'title',
        alignment: 'left',
      },
      {
        id: 'typology',
        name: t('kpi_typology_column'),
        accessor: 'typology',
        renderRow: (row) => <Typology type={row.typology} />,
      },
      {
        id: 'createdAt',
        name: t('kpi_createdAt_column'),
        accessor: 'createdAt',
        renderRow: (row) =>
          row.createdAt.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          }),
      },
      {
        id: 'claimant',
        name: t('kpi_claimant_column'),
        accessor: 'createdBy',
        renderRow: (row) => row.createdBy?.fullName ?? '',
      },
      {
        id: 'status',
        name: t('kpi_status_column'),
        accessor: 'status',
        renderRow: (row) => <Status status={row.status} />,
      },
    ],
    [],
  );

  return (
    <KpiDetailsModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('requests_kpi_details_title')}
      columns={columns}
      filterByValues={allowedFilterByTypes}
      orderByValues={allowedOrderByTypes}
    />
  );
};
